module.exports = __webpack_public_path__ + "img/share-app.24c67498.svg";